import RoundedBoxComponent from "../race/block/RoundedBoxComponent.jsx";
import { COLORS } from "../../constants/colors";

const TowerPyramid = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  color = COLORS.yellow,
}) => {
  const baseSize = 2; // Размер основания
  const height = 5; // Высота башни
  const cubeSize = 0.4; // Размер кубика
  const spacing = 0.05; // Расстояние между кубиками
  const radius = 0;
  const totalSize = cubeSize + spacing;

  const cubes = [];

  // Создаем башню по слоям
  for (let row = 0; row < height; row++) {
    for (let x = 0; x < baseSize; x++) {
      for (let z = 0; z < baseSize; z++) {
        cubes.push(
          <RoundedBoxComponent
            key={`${row}-${x}-${z}`}
            position={[
              (x - baseSize / 2) * totalSize,
              row * totalSize,
              (z - baseSize / 2) * totalSize,
            ]}
            size={cubeSize}
            radius={radius}
            mass={row === 0 ? 0.5 : 0.0001}
            friction={0.9}
            restitution={0.05}
            linearDamping={0.8}
            angularDamping={0.9}
            color={color}
          />
        );
      }
    }
  }

  return (
    <group position={position} rotation={rotation}>
      {cubes}
    </group>
  );
};

export default TowerPyramid;
